interface PropertyValue {
  value?: string
  richText?: string
  blocks?: any[] // Adjust the type as per your data structure if needed
  mediaItems?: { url: string }[]
  links?: []
  dateTime?: string
  contentList?: any
}

interface DataProperty {
  propertyName: string | null
  propertyValue: PropertyValue | null
}

interface Data {
  properties?: DataProperty[]
}

export function extractPropertyMediaItems(
  data: Data | any,
  propertyName: string,
  allMedia?: boolean,
): any {
  if (!data || !propertyName) {
    return ""
  }

  const property = data.properties?.find((prop: DataProperty) => prop.propertyName === propertyName)

  if (!property?.propertyValue) {
    return ""
  }
  if (allMedia) {
    return property.propertyValue.mediaItems
  }

  if (property.propertyValue?.mediaItems?.length > 0) {
    return property.propertyValue?.mediaItems?.map((mediaItem: any) => mediaItem?.url) || ""
  } else return property.propertyValue?.mediaItems?.[0]?.url || ""
}
